<!--约教练退款-->
<template lang="pug">
    d2-container
      el-form(:inline='true', :model='dataForm'  size='mini' label-position='right' label-width='75px' label-suffix=':')
        el-row(:span='24')
          el-col(:md='6' :sm='8')
             el-form-item(label='教练手机号')
                el-input.inputWidth(v-model='dataForm.coachMobile', placeholder='教练手机号', clearable='')
          el-col(:md='6' :sm='8')
             el-form-item(label='教练姓名' label-position='right')
                el-input.inputWidth(v-model='dataForm.coachName', placeholder='教练姓名', clearable='')
          el-col(:md='6' :sm='8')
             el-form-item(label='学员账号' label-position='right')
                el-input.inputWidth(v-model='dataForm.account', placeholder='学员账号', clearable='')
          el-col(:md='6' :sm='8')
             el-form-item(label='学员姓名' label-position='right')
                el-input.inputWidth(v-model='dataForm.name', placeholder='学员姓名', clearable='')
        el-row(:span='24')
        el-row(:span='24')
          el-col(:md='6' :sm='8')
              el-form-item(label='申请时间')
                 el-date-picker(style='width:210px', v-model='dataForm.rangeTime' range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd")
        el-row(:span='24')
          el-col(:span='12' style="padding-bottom:15px;float:right")
            el-button(@click='getDataList()',type='primary',icon='el-icon-search' style='float:right;') 查 询
        el-table(:data="tableData" style="width: 100%" v-loading='dataListLoading' border)
            el-table-column(prop='coachName' header-align='center',align='center',label='教练姓名'  )
            el-table-column(prop='coachMobile' header-align='center',align='center',label='教练手机号' width="150")
            el-table-column(header-align='center',align='center',label='学员姓名')
              template(slot-scope="scope")
               font {{ scope.row.name }}
            el-table-column(header-align='center',align='center',label='学员账号' width="150")
              template(slot-scope="scope")
               font {{ scope.row.accout }}
            el-table-column(header-align='center',align='center',label='日期'  )
              template(slot-scope="scope")
               font {{ scope.row.subscribeDate }}
            el-table-column(header-align='center',align='center',label='时间段')
              template(slot-scope="scope")
               font {{ scope.row.subscribeTime }}
            el-table-column(header-align='center',align='center',label='场地' )
              template(slot-scope="scope")
               font {{ scope.row.placeName }}
            el-table-column(header-align='center',align='center',label='申请时间' width="200")
              template(slot-scope="scope")
               font {{ scope.row.applyTime }}
            el-table-column(prop='payAmount' header-align='center',align='center',label='支付金额')
              template(slot-scope="scope" v-if="scope.row.payAmount")
                font ￥{{ parseFloat(scope.row.payAmount).toFixed(2) }}元
            el-table-column(prop='refundProportion' header-align='center',align='center',label='退款比例')
              template(slot-scope="scope" v-if="scope.row.refundProportion")
                font {{ scope.row.refundProportion }}%
            el-table-column(header-align='center',align='center',label='退款金额')
              template(slot-scope="scope" v-if="scope.row.refundMoney")
                font ￥{{ parseFloat(scope.row.refundMoney).toFixed(2) }}元
            el-table-column(prop='statusName' header-align='center',align='center',label='状态')
            //- el-table-column(prop='remark' header-align='center',align='center',label='备注')
            //- el-table-column(header-align='center',align='center',label='操作')
            //-     template(slot-scope="scope")
            //-       el-menu.menuPonit(:collapse="isCollapse")
            //-             el-submenu(index="1")
            //-                 template(slot="title")
            //-                     i(class="el-icon-more" style='color:#02B90D;')
            //-                 el-menu-item-group()
            //-                     el-menu-item(index="1-1"   @click="confirmRefund(scope.row.id)" :disabled='scope.row.status!==5' v-if="isAuth('')" ) 确认退款
            //-                     el-menu-item(index="1-2"   @click="returnApply(scope.row.id)" :disabled='scope.row.status!==5'   v-if="isAuth('')" ) 退回申请
        el-pagination(@size-change='sizeChangeHandle', @current-change='currentChangeHandle', :current-page='pageIndex', :page-sizes='[10, 20, 50, 100]', :page-size='pageSize', :total='totalPage', layout='total, sizes, prev, pager, next, jumper')
</template>
<script>
import { get30DaysArray } from '@/util/dateUtils'

export default {
  name: 'finance-competitionOrder-reserveSiteRefund',
  data () {
    return {
      isCollapse: true,
      table: {
        data: null,
        size: 'mini',
        stripe: true,
        border: true
      },
      detailVisiable: false,
      dataForm: {
        account: '', // 查询参数
        appyBegin: '',
        appyEnd: '',
        name: '',
        rangeTime: [],
        coachMobile: '',
        coachName: ''
      },
      tableData: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false
    }
  },
  mounted () {
    this.dataForm.rangeTime = get30DaysArray()
    this.getDataList()
  },
  methods: {
    // 获取数据列表
    getDataList () {
      this.dataListLoading = true
      let [startTime = null, endTime = null] = this.dataForm.rangeTime || []
      this.dataForm.appyBegin = startTime
      this.dataForm.appyEnd = endTime
      // TODO 约场地退款接口,需替换
      this.$http({
        url: this.$http.adornUrl('/payRefund/refund-list-subscribe'),
        method: 'POST',
        params: this.$http.adornParams({
          limit: this.pageSize, //必须放  不然过不去
          page: this.pageIndex
        }),
        data: this.dataForm
      }).then((data) => {
        if (data && data.code === 0) {
          this.tableData = data.data.rows
          this.totalPage = data.data.total
        } else {
          this.tableData = []
          this.totalPage = 0
          this.totalMoney = 0
        }
        this.dataListLoading = false
      })
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getDataList()
    },
    confirmRefund (id) {
      console.log('确认退款', id)
      this.$http({
        url: this.$http.adornUrl('/payRefund/confirmRefund'),
        method: 'post',
        params: this.$http.adornParams({
          id: id
        })
      }).then((data) => {
        if (data.code === 0) {
          this.$message.success('退款成功!')
          this.getDataList()
        } else {
          this.$message.success('退款失败!')
        }
      })
    },
    returnApply (id) {
      console.log('退回申请', id)
      this.$http({
        url: this.$http.adornUrl('/payRefund/returnApply'),
        method: 'post',
        params: this.$http.adornParams({
          id: id
        })
      }).then((data) => {
        if (data.code === 0) {
          this.$message.success('退回申请成功!')
          this.getDataList()
        } else {
          this.$message.success('退回申请失败!')
        }
      })
    }
  }
}
</script>
<style>
.el-form--inline .el-form-item__label {
  width: 91px !important;
}
.inputWidth {
  width: 210px;
}
.el-form--inline .el-form-item {
  display: inline-block;
  margin-right: 0px;
  vertical-align: top;
}
</style>
<style >
/* 操作三点 菜单样式 */
@import '../../../css/opr3dot.css';
</style>
